<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">收徒</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <li class="pupil-block" v-for="(item, index) in data" :key="index" >
      <div class="pupil ub ub-pc" v-if="item.s_total<30000">
        <img :src="item.photo" class="photo" />
        <div class="ub ub-f1 ub-pc ub-ac2">
          <div class="ub ub-ver ub-f1">
            <div class="ub ub-ac2">
              <div>
                <span class="sp1">{{ item.nick }}</span>
                <span class="day">注册时长:<label class="la">{{ item.difday }}</label>天</span>
              </div>
            </div>

            <div class="ub sex-item">
              <div class="sex-width ub ub-pc">
                <img v-if="item.sex == '女生'" src="../../assets/img/女.png" class="sex-img"/>
                <img v-if="item.sex == '男生'" src="../../assets/img/男.png" class="sex-img"/>
                <span :class="item.sex == '女生' ? 'sex' : 'sex2'">{{item.sex}}</span>
              </div>
              <span class="ub ub-pc day">总魅力值:<label class="lb">{{ item.s_total }}</label></span>
            </div>
          </div>
          <span class="btn" @click="goto_chat(item.uid)">收徒</span>
        </div>
      </div>
    </li>

    <div class="ub ub-pc ub-ac loadmore" @click="load_more()">加载更多</div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      data: [],
      index: 0,
      size: 10,
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.load_more();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    load_more() {
       this.$loading('加载...');

      var self = this;
      self.get({
        url:"/App/GetApprenticeCan/?index=" + self.index + "&size=" + self.size,
        success: function (data) {
          self.$loading.close();

          if(data.length <= 0 && self.index > 0){
            self.$toast.center("没有更多了~");
          }

          self.index++;
          //console.log(JSON.stringify(data));
          for (var i = 0; i < data.length; i++) {
            data[i].photo = self.$store.state.url + "/photo/" + data[i].photo;
          }
          self.data = self.data.concat(data);
        },
      });
       
    },
   goto_chat(uid) {
      this.$router.push({ name: "chart", params: { uid: uid } });
    },
  },
};
</script>

<style lang="scss" scoped>
.pupil-block {
  font-size: 0.85rem;
  background-color: #fff;
  .pupil {
    border-bottom: 1px solid #dcdcdc;
    padding: 1.2rem 0.8rem 1.2rem 0.8rem;
    .photo {
      width: 3.8rem;
      height: 3.8rem;
      border-radius: 50%;
      margin-right: 0.5rem;
    }
    .sp1 {
      display: inline-block;
      width: 6rem;
    }
    .day {
      margin: 0 0.5rem;
      color: #888;
      .la {
        margin: 0 0.15rem;
        color: #333;
        font-weight: bold;
        font-size: 1.2rem;
      }
      .lb {
        color: #333;
        font-size: 1.2rem;
        font-weight: bold;
      }
    }
    .sex-item {
      margin-top: 0.6rem;
    }
    .sex-width {
      width: 6rem;
      color: #ff3ec9;
      .sex-img {
        width: 1.25rem;
      }
      .sex {
        color: #ff3ec9;
      }
      .sex2 {
        color: #37b8d5;
      }
    }
    .btn {
      border: 1px solid #e92162;
      padding: 0.3rem 1.5rem;
      border-radius: 0.3rem;
      color: #e92162;
      font-size: 1rem;
    }
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .pupil-block {
    color: #fff;
    background-color: #2c2b30;
    .pupil {
      .day {
        .la {
          color: #888;
        }
        .lb {
          color: #888;
        }
      }
    }
  }
}
</style>